var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clock-in",class:{'grey':_vm.isClock,'hide':_vm.hide},on:{"click":function($event){!_vm.isClock&&_vm.clock()}}},[_vm._v("\n    "+_vm._s(_vm.isClock?"已打卡":"打卡")+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }